<template>
  <el-dialog
      :visible.sync="dialogVisible"
      style="padding: 5px"
      append-to-body
      title="文件预览"
      top="0vh"
      width="80%">
    <pdf-viewer-v2 ref="pdfViewer" :pdf-url="pdfUrl"/>
  </el-dialog>
</template>

<script>
  import PdfViewerV2 from "@/components/pdfViewer/PdfViewerV2.vue";

  export default {
    components: {PdfViewerV2},
    data() {
      return {
        dialogVisible: false,
        pdfUrl: "",
      };
    },
    methods: {
      open(url) {
        this.pdfUrl = window.config.basicServerUrl + url;
        console.log(this.pdfUrl);
        this.dialogVisible = true;
      },
    },
  };
</script>
